<template>
  <b-row ref="aba-contato">
    <b-col>
      <b-row>
        <b-col cols="6">
          <h4>Contatos</h4>
          <fieldset class="font-weight-bold text-muted small">
            Cadastre os contatos que receberão a notificação de cobrança de documentos
          </fieldset>
        </b-col>
        <b-form-group class="col-6 my-0 pb-0">
          <b-form-checkbox
            v-model="empresa.mostrarDocumentosContato"
            class="custom-control-primary"
            style="float:right"
            name="check-button"
            switch
          >
            <label style="font-size: 1rem">Exibir documentos</label>
          </b-form-checkbox>
        </b-form-group>
      </b-row>
      <b-row>
        <b-col cols="12">
          <hr
            class="mx-0 mt-0 mb-2"
            style="border-top: 1px solid #a3a4a66b !important;"
          >
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <contato-row
            v-for="(item, $index) in contatos"
            :key="$index"
            v-model="contatos[$index]"
            :show-more="empresa.mostrarDocumentosContato"
            @novo="novoContato"
            @remove="removeContato"
          />
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Contato',
  components: { ContatoRow: () => import('./shared/components/contato-row/ContatoRow.vue') },
  data() {
    return {
      contatos_: [],
    }
  },
  computed: {
    ...mapGetters('empresa', ['empresa', 'contatos']),
  },
  methods: {
    ...mapActions('empresa', ['adicionarContato']),
    novoContato() {
      const ultimoContato = this.contatos[this.contatos.length - 1]

      if (ultimoContato.usuario && ultimoContato.departamentos.length > 0) {
        this.adicionarContato()
        this.adicionaPorCima()
      }
    },
    removeContato(value) {
      // eslint-disable-next-line no-param-reassign
      value.usuario = null
      const index = this.contatos
        .findIndex(f => (f.code && value.code === f.code) || (!f.code && f.id === value.id))
      this.contatos.splice(index, 1)

      if (this.contatos.length === 0) {
        this.adicionarContato()
      }
    },
    adicionaPorCima() {
      const ultimoAdicionado = this.contatos[this.contatos.length - 1]
      this.contatos.splice(this.contatos.length - 1, 1)
      this.contatos.splice(0, 0, ultimoAdicionado)
    },
  },
}
</script>
